webpackJsonp([96068746775097],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0px 0px 10px;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n'], ['\n  margin: 0px 0px 10px;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  color: #333;\n  ', ':hover & {\n    color: seagreen;\n    text-decoration: underline;\n  }\n  ', '\n\n'], ['\n  text-decoration: none;\n  color: #333;\n  ', ':hover & {\n    color: seagreen;\n    text-decoration: underline;\n  }\n  ', '\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.8;\n'], ['\n  line-height: 1.5rem;\n  font-size: 1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.8;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(30);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	
	var Publication_Item = function Publication_Item(props) {
	  return _react2.default.createElement(
	    PubCard,
	    null,
	    _react2.default.createElement(
	      PublicationTitle,
	      null,
	      props.pub.title
	    ),
	    _react2.default.createElement(
	      PublicationAuthors,
	      null,
	      props.pub.authors.map(function (author, i) {
	        if (author === 'A.E. Zimmerman' || author === 'Zimmerman' || author === 'A.E.') {
	          return _react2.default.createElement(
	            'strong',
	            { key: i },
	            author,
	            props.pub.authors.length - 1 > i ? ', ' : ''
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { key: i },
	            author,
	            props.pub.authors.length - 1 > i ? ', ' : ''
	          );
	        }
	      })
	    ),
	    _react2.default.createElement(
	      PublicationDetails,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        props.pub.year
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u2013 '
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        props.pub.journal
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u2013 '
	      ),
	      _react2.default.createElement(
	        ALink,
	        { href: props.pub.abstractUrl,
	          target: '_blank' },
	        props.pub.doiNumber
	      )
	    )
	  );
	};
	
	exports.default = Publication_Item;
	
	
	var PubCard = _Card2.default.extend(_templateObject);
	
	var ALink = _styledComponents2.default.a(_templateObject2, PubCard, '' /* &:hover {
	                                                                       color: seagreen;
	                                                                       } */);
	
	var PublicationTitle = _styledComponents2.default.h2(_templateObject3);
	
	var PublicationAuthors = _styledComponents2.default.p(_templateObject4);
	
	var PublicationDetails = _styledComponents2.default.p(_templateObject5);
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Publication_Item = __webpack_require__(200);
	
	var _Publication_Item2 = _interopRequireDefault(_Publication_Item);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublicationsPage = function PublicationsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Container2.default,
	    { grey: true, page: true },
	    _react2.default.createElement(
	      _InnerContainer2.default,
	      null,
	      _react2.default.createElement(
	        _SectionHeader2.default,
	        null,
	        'Publications'
	      ),
	      data.allContentfulPublication.edges.map(function (edge, i) {
	        return _react2.default.createElement(_Publication_Item2.default, { key: i, pub: edge.node });
	      })
	    )
	  );
	};
	
	exports.default = PublicationsPage;
	var query = exports.query = '** extracted graphql fragment **';
	
	// const Container = styled.div`
	//   background-color: #eee;
	//   flex-direction: column;
	//   justify-content: center;
	//   padding: 40px 10px;
	//   min-height: 100vh;
	//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	// `;
	//
	// const InnerContainer = styled.div`
	//   max-width: 960px;
	//   margin: auto;
	//   padding: 20px;
	//   color: #333;
	// `;
	//
	// const SectionHeader = styled.h1`
	//   text-align: center;
	//   font-weight: 300;
	// `;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-publications-js-308af670202ad030deec.js